"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import { type Benefit, benefitsDefault } from "./benefits-eon-hungary-data";
export default function BenefitsHungary(_props) {
  const $ = _c(11);
  const t = useLanguage();
  let t0;
  if ($[0] !== t) {
    t0 = benefitsDefault(t);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const benefits = t0;
  let t1;
  if ($[2] !== t.jobad_benefits_headline) {
    t1 = <h2 className="font-bold text-4xl text-clientFont">{t.jobad_benefits_headline}</h2>;
    $[2] = t.jobad_benefits_headline;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== benefits) {
    t2 = benefits.map(_temp);
    $[4] = benefits;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <ul className="grid grid-flow-row auto-rows-fr grid-cols-1 gap-5 md:grid-cols-2 xl:gap-8">{t2}</ul>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <section className="w-full overflow-hidden px-6 py-10 md:px-10 md:py-20 print:hidden" id="benefits"><div className="mx-auto flex h-full w-full max-w-screen-xl flex-col justify-center gap-y-8">{t1}{t3}</div></section>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(entry) {
  return <FlipCard key={entry.title} {...entry} />;
}
function FlipCard(t0) {
  const $ = _c(18);
  const {
    title,
    text,
    icon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      perspective: "600px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backfaceVisibility: "hidden"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== icon) {
    t3 = <div className="mb-4 flex h-20 w-20 items-center justify-center rounded-xl bg-white">{icon}</div>;
    $[2] = icon;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== title) {
    t4 = <h3 className="my-2 font-bold text-2xl lg:text-3xl">{title}</h3>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== text) {
    t5 = <div className="md:hidden"><p>{text}</p></div>;
    $[6] = text;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex w-full flex-col justify-center bg-primary p-6 text-white transition-transform duration-500 will-change-transform md:group-hover:[transform:rotateX(180deg)]" style={t2}>{t3}{t4}{t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backfaceVisibility: "hidden",
      marginRight: "-100%"
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== text) {
    t8 = <div className="flex w-full flex-col items-center justify-center bg-primary p-6 text-center text-white transition-transform duration-500 will-change-transform [transform:rotateX(-180deg)_translateX(-100%)] md:group-hover:[transform:rotateX(0deg)_translateX(-100%)]" style={t7}>{text}</div>;
    $[13] = text;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <li className="group flex cursor-pointer text-lg" style={t1}>{t6}{t8}</li>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}